import { Box } from 'components/Box';
import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { VideoThumbnail } from 'components/VideoThumbnail';
import { ShowModalContainer } from 'containers/ShowModalContainer';
import {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockVideo,
} from 'modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import { colors, gutterWidth } from 'theme/theme';

type Props = {
  appearance: CmsApiSplitBlockAppearance;
  blockId: string;
  index: number;
  preview: boolean;
  section: CmsApiSplitBlockVideo;
};

export function CmsSplitContentVideoContent({
  appearance,
  blockId,
  index,
  preview,
  section,
}: Props) {
  const overlapping = appearance === 'OVERLAPPING';
  const fullWidth = appearance === 'FULL_WIDTH';

  return (
    <Box
      data-qa-id={`split-content-section-${index}`}
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'Position | ... Remove this comment to see the full error message
      position={[undefined, null, !fullWidth ? 'relative' : undefined]}
      width={[1, null, 1 / 2]}
      px={[gutterWidth / 4, null, gutterWidth / 2]}
      py={[gutterWidth / 4, null, gutterWidth / 2]}
      key={blockId}
    >
      <Box
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'Position | ... Remove this comment to see the full error message
        position={[null, null, fullWidth && !preview ? 'absolute' : undefined]}
        left={[null, null, '50%']}
        top={[null, null, '50%']}
        transform={[
          null,
          null,
          fullWidth && !preview ? 'translate(-50%, -50%)' : null,
        ]}
        height={[
          '100%',
          null,
          overlapping || fullWidth
            ? `calc(100% + ${overlapping ? gutterWidth * 2 : gutterWidth}px)`
            : '100%',
        ]}
        // @ts-expect-error TS(2322): Type 'false | (number | null)[]' is not assignable... Remove this comment to see the full error message
        mt={overlapping && [0, null, -gutterWidth]}
        width={
          overlapping
            ? [
                1,
                null,
                fullWidth ? '100vw' : `calc(100% + ${gutterWidth * 3}px)`,
              ]
            : 1
        }
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | nu... Remove this comment to see the full error message
        ml={[0, null, overlapping && index === 1 && -gutterWidth * 3]}
        overflow="hidden"
        borderRadius="24px"
        bg={colors.backgroundGrey}
      >
        <ShowModalContainer
          render={(showModal) => (
            <Box
              component={Button}
              position="relative"
              width="100%"
              height="100%"
              minHeight={['50vw', null, '25vw', (540 * 9) / 16]}
              onClick={() => {
                showModal('MEDIA_GALLERY', {
                  // @ts-expect-error TS(2322): Type '{ type: string; videoUrl: string; }' is not ... Remove this comment to see the full error message
                  items: [{ type: 'VIDEO', videoUrl: section.data.url }],
                  itemIndex: 0,
                  hideCaptionContainer: true,
                });
              }}
              aria-label={getText('Open video')}
            >
              <VideoThumbnail
                src={{ type: 'video-thumbnail', videoUrl: section.data.url }}
                size={{ type: 'expand' }}
                playButton={fullWidth ? undefined : 'large'}
                qaId="split-block-video-image"
              />
            </Box>
          )}
        />
      </Box>
    </Box>
  );
}
